const getTestId = (...props: (string | number)[]) => {
  return props
    .map((value) => `${value}`)
    .map((value) => value.replace(/\.|\[/gm, '-'))
    .map((value) => value.replace(']', ''))
    .join('-');
};

export default getTestId;
